/* eslint-disable @typescript-eslint/naming-convention */
import { BaseRequestModel } from '../models/base-request.model';

export const getBaseRequestParams = (function () {
    const sessionId = window.crypto.randomUUID();
    return (): BaseRequestModel => {
        return {
            session_id: sessionId,
            source: 'frontend',
            trace_id: window.crypto.randomUUID(),
            version: '1.0',
        };
    };
})();
